export default "__VITE_ASSET__CzAklT$Y__"